import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import Textfit from 'react-textfit'
import classNames from 'classnames'
import DropDownCaret from 'public/assets/svg/DropDownCaret.svg'

const styleSheet = theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: ({ useResponsiveUI }) => (!useResponsiveUI ? 'calc(100% - 117px)' : '100%'),
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        color: theme.palette.common.white,
    },
    standardTitle: {
        fontSize: 28,
        height: 82,
    },
    embeddedTitle: {
        fontSize: ({ viewportWidth }) => (viewportWidth >= 700 ? 24 : 20),
        marginRight: '0.8em',
        // em doesn't seem reliable across various contexts.  Don't want to change 1.2em b/c of possible side-effects, but switching to px for embed
        top: ({ useResponsiveUI }) => (!useResponsiveUI ? '1.2em' : '24px'),
        left: '0.6em',
        position: 'relative',
    },
    icon: {
        width: 30,
        height: 10,
        paddingBottom: 5,
    },
})

const style = injectSheet(styleSheet)

const StopTitle = ({ classes, className, title, onClick, useResponsiveUI }) => (
    <div className={classNames(classes.container, className)} onClick={!useResponsiveUI && onClick}>
        {!useResponsiveUI ? (
            <Textfit className={classNames(classes.title, classes.standardTitle)} mode="multi" min={14} max={36}>
                {title}
                <img className={classes.icon} src={DropDownCaret} />
            </Textfit>
        ) : (
            <Textfit className={classNames(classes.title, classes.embeddedTitle)} mode="multi">
                {title}
            </Textfit>
        )}
    </div>
)

export default compose(style)(StopTitle)
